<template>
  <NsiTable :pageTitle="pageTitle" :apiRoute="apiRoute" :cardName="cardName" :canEdit="canEdit" />
</template>

<script>
  import NsiTable from '../components/NsiTable.vue';

  export default {
    name: 'DocumentTags',
    components: {
      NsiTable,
    },
    data() {
      return {
        pageTitle: 'Теги документов',
        canEdit: true,
        apiRoute: 'nsidocumenttag',
        cardName: 'DocumentTagCard',
      };
    },
    created() {},
    methods: {},
  };
</script>
